export default __webpack_public_path__ + "static/media/dp.1f6bd6eb.svg";